import Gallery from './Gallery';

document.addEventListener('DOMContentLoaded', () => {
  const $galleryElements = document.querySelectorAll('.js-gallery');
  if (!$galleryElements.length) {
    return;
  }
  $galleryElements.forEach(($gallery) => {
    const gallery = new Gallery($gallery);
    gallery.mount();
  });
});
